import React from 'react'
import useIsInViewport from 'use-is-in-viewport'
import {FiArrowDownRight} from 'react-icons/fi'

function Contact() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="Contact" id="contact">
				<div>
					<h2>Let's connect!</h2>
					<p>I am currently looking for a position in Frontend or FullStack Development. Feel free to connect with me or send me an email with the buttons on the bottom right of the screen</p><FiArrowDownRight size="2em" />
				</div>
			</div>
		</div>
	  )
}

export default Contact

